import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from 'clsx';
import { AlertCircle } from 'lucide-react';
import * as React from 'react';
const Alert = React.forwardRef(({ className, variant = 'default', ...props }, ref) => {
    return (_jsx("div", { ref: ref, role: "alert", className: clsx('relative w-full rounded-lg border p-4', {
            'bg-white text-gray-900': variant === 'default',
            'bg-red-50 text-red-900 border-red-200': variant === 'destructive',
        }, className), ...props }));
});
Alert.displayName = 'Alert';
const AlertDescription = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: clsx('text-sm [&_p]:leading-relaxed', className), ...props })));
AlertDescription.displayName = 'AlertDescription';
export { Alert, AlertDescription, AlertCircle };
